/**
 * DREAMMANE CUSTOM — Variant Picker Price Fix
 * --------------------------------------------------------------------
 * Problem: Wenn "Alle Farben" aktiv ist und der User die Länge ändert,
 * wird manchmal kein Preis angezeigt, weil die Farb-Option nicht als
 * "ausgewählt" erkannt wird.
 *
 * Lösung: Wir stellen sicher, dass immer mindestens eine Farb-Radio
 * gecheckt ist. Wenn nach einem variant-picker Rerender keine Farb-Radio
 * gecheckt ist, checken wir die erste sichtbare (nicht gefilterte) Farbe.
 *
 * Außerdem: Beim Länge-Change prüfen wir, ob alle Options-Positionen
 * einen checked Input haben. Falls nicht, checken wir den ersten
 * verfügbaren Input für die fehlende Position.
 */
(function () {
  'use strict';

  function ensureAllOptionsChecked(form) {
    if (!form) return;

    // Finde alle Option-Inputs die zum Form gehören
    var inputs = Array.from(form.elements).filter(function (el) {
      return el.matches && el.matches('input[data-option-position]');
    });

    if (!inputs.length) return;

    // Gruppiere nach Option-Position
    var positions = {};
    inputs.forEach(function (input) {
      var pos = input.getAttribute('data-option-position');
      if (!positions[pos]) positions[pos] = [];
      positions[pos].push(input);
    });

    // Prüfe ob jede Position einen checked Input hat
    var needsReselect = false;
    Object.keys(positions).forEach(function (pos) {
      var group = positions[pos];
      var hasChecked = group.some(function (input) { return input.checked; });
      if (!hasChecked && group.length > 0) {
        // Kein checked Input für diese Position — wähle den ersten
        // nicht-disabled, sichtbaren Input
        var fallback = group.find(function (input) {
          return !input.disabled;
        });
        if (fallback) {
          fallback.checked = true;
          needsReselect = true;
        }
      }
    });

    return needsReselect;
  }

  // Nach jedem variant-picker Rerender: sicherstellen dass alle Optionen gecheckt sind
  function onDomChange(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      for (var j = 0; j < m.addedNodes.length; j++) {
        var node = m.addedNodes[j];
        if (node.nodeType !== 1) continue;

        // Prüfe ob ein variant-picker oder ein Block mit data-block-type="variant-picker"
        // eingefügt wurde (= Rerender)
        var isPicker = (node.matches && node.matches('variant-picker, [data-block-type="variant-picker"]'));
        var hasPicker = node.querySelector && node.querySelector('variant-picker, [data-block-type="variant-picker"]');

        if (isPicker || hasPicker) {
          // Finde das zugehörige Form
          var picker = isPicker ? node : hasPicker;
          var vp = picker.closest('variant-picker') || picker.querySelector('variant-picker') || picker;
          var formId = vp.getAttribute && vp.getAttribute('form-id');
          if (formId && document.forms[formId]) {
            ensureAllOptionsChecked(document.forms[formId]);
          }
        }
      }
    }
  }

  // MutationObserver für Rerender-Events
  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(onDomChange);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // Auch beim initialen Load sicherstellen
  function initAll() {
    document.querySelectorAll('variant-picker').forEach(function (vp) {
      var formId = vp.getAttribute('form-id');
      if (formId && document.forms[formId]) {
        ensureAllOptionsChecked(document.forms[formId]);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
